export const ICONFERENCE = '/iconference/' as const
export const ICONFERENCE_ALL = `${ICONFERENCE}all` as const
export const ICONFERENCE_ALL_FILTER = `${ICONFERENCE_ALL}/filter` as const
export const ICONFERENCE_CATEGORY_ALL = `${ICONFERENCE}category/all` as const
export const ICONFERENCE_ARTICLE_LIST = '/iconference/article' as const
export const ICONFERENCE_ARTICLE = `${ICONFERENCE}article/` as const
export const ICONFERENCE_ARTICLE_ALL = `${ICONFERENCE}article/all` as const
export const ICONFERENCE_MAGAZINE_ARTICLE = `${ICONFERENCE}magazine/article` as const
export const ICONFERENCE_ARTICLE_STEP = `${ICONFERENCE}article/step` as const
export const ICONFERENCE_ARTICLE_PROOF = `${ICONFERENCE}article/proof` as const
